var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 3.4H4C3.11634 3.4 2.4 4.11634 2.4 5V20C2.4 20.8837 3.11634 21.6 4 21.6H20C20.8837 21.6 21.6 20.8837 21.6 20V5C21.6 4.11634 20.8837 3.4 20 3.4H17.6V1H16.4V3.4H7.6V1H6.4V3.4ZM4 4.6C3.77909 4.6 3.6 4.77909 3.6 5V8.35H20.4V5C20.4 4.77909 20.2209 4.6 20 4.6H4ZM20.4 9.55H3.6V20C3.6 20.2209 3.77909 20.4 4 20.4H20C20.2209 20.4 20.4 20.2209 20.4 20V9.55Z"
  })));
};
export default SvgCalendar;